import { Injectable } from '@angular/core';
import { IApiRouteService } from '../../models/route';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiFilesGoogleService extends IApiRouteService {
  urlRoute = environment.otherApis.files + '/api/google';

  getAuthUrl(): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.urlRoute}/auth`);
  }

  getTokens(code: string): Observable<{
    tokens: {
      access_token: string;
      scope: string;
      token_type: string;
      expiry_date: number;
    };
  }> {
    return this.http.get<{
      tokens: {
        access_token: string;
        scope: string;
        token_type: string;
        expiry_date: number;
      };
    }>(`${this.urlRoute}/tokens?code=${code}`);
  }
}
